import "core-js/modules/es6.regexp.match";
import request from "@/utils/request";
export function getProvisionInfo() {
  return request({
    url: "/v1/customers/self-info",
    method: "get"
  });
}
export function exportExcel(params) {
  request({
    url: "/v1/customers/export-data",
    method: "post",
    data: params,
    responseType: "arraybuffer"
  }).then(function (res) {
    var blob = new Blob([res.data], {
      type: "application/octet-stream;charset=UTF-8"
    });
    var href = URL.createObjectURL(blob);
    var downloadElement = document.createElement("a");
    var fileName = res.headers["content-disposition"].match(/filename=(.*)/)[1];
    downloadElement.href = href;
    downloadElement.download = decodeURI(fileName);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
  });
}
export function exportExcelCardBuyCrypto(params) {
  request({
    url: "/v1/customers/exchange/tx/list/export",
    method: "post",
    data: params,
    responseType: "arraybuffer"
  }).then(function (res) {
    var blob = new Blob([res.data], {
      type: "application/octet-stream;charset=UTF-8"
    });
    var href = URL.createObjectURL(blob);
    var downloadElement = document.createElement("a");
    var fileName = res.headers["content-disposition"].match(/filename=(.*)/)[1];
    downloadElement.href = href;
    downloadElement.download = decodeURI(fileName);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
  });
}
export function deleteApi(key, emailCode, ga, token) {
  return request({
    url: "/v1/customers/open-api",
    method: "delete",
    data: {
      api_key: key,
      mail_verify_token: token
    },
    headers: {
      "email-code": emailCode,
      "ga-code": ga
    }
  });
}
export function getApiSecret(key, googleCode, passphrase) {
  return request({
    url: "/v1/customers/open-api/".concat(key),
    method: "get",
    headers: {
      "ga-code": googleCode
    },
    params: {
      passphrase: passphrase
    }
  });
}
export function submitCreateApi(emailCode, googleCode, params) {
  return request({
    url: "/v1/customers/open-api",
    method: "post",
    headers: {
      "ga-code": googleCode,
      "email-code": emailCode
    },
    data: params
  });
}
export function submitEditApi(emailCode, googleCode, params) {
  return request({
    url: "/v1/customers/open-api",
    method: "put",
    headers: {
      "ga-code": googleCode,
      "email-code": emailCode
    },
    data: params
  });
}

// bycardPay below

export function getBalance(params) {
  return request({
    url: "/v1/customers/npay/asset",
    method: "get",
    params: params
  });
}
export function getChargeSettings() {
  return request({
    url: "/v1/customers/npay/asset/setting",
    method: "get"
  });
}
export function uploadFile(file) {
  var formData = new FormData();
  formData.append("file", file);
  return request({
    url: "/v1/common/file/public",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
}
export function submitEditWebhook(googleCode, params) {
  return request({
    url: "/v1/customers/webhook",
    method: "put",
    headers: {
      "ga-code": googleCode
    },
    data: params
  });
}
export function getWebhookSecret(googleCode) {
  return request({
    url: "/v1/customers/notify-secret",
    method: "get",
    headers: {
      "ga-code": googleCode
    }
  });
}
export function getWithdrawRecords(params) {
  return request({
    url: "/v1/customers/asset/list",
    method: "post",
    data: params
  });
}
export function getCoinAddressOptions(coin) {
  return request({
    url: "/v1/customers/address/list/".concat(coin),
    method: "get"
  });
}
export function getWalletBalance(coin) {
  return request({
    url: "/v1/customers/asset/".concat(coin),
    method: "get",
    params: {
      address_type: 0 // 只有充值备付金可体现
    }
  });
}
export function getWithdrawAddress() {
  return request({
    url: "/v1/customers/address/list",
    method: "get",
    params: {
      page_index: 1,
      page_offset: 100
    }
  });
}
export function submitAddWithdrawAddress(params, googleCode) {
  return request({
    url: "/v1/customers/address",
    method: "post",
    headers: {
      "ga-code": googleCode
    },
    data: params
  });
}
export function deleteWithdrawAddress(params, emailCode, googleCode) {
  return request({
    url: "/v1/customers/address",
    method: "delete",
    data: params,
    headers: {
      "email-code": emailCode,
      "ga-code": googleCode
    }
  });
}
export function submitWithdrawApply(params, emailCode, googleCode) {
  return request({
    url: "/v1/customers/asset/withdraw",
    method: "post",
    headers: {
      "ga-code": googleCode,
      "email-code": emailCode
    },
    data: params
  });
}
export function getCornList() {
  // todo 修复拼写
  return request({
    url: "/v1/common/coin-type",
    method: "get"
  });
}

//获取airwalletex 数据
export function getAirwallexCard() {
  return request({
    url: "/v1/admin/airwallex/card",
    method: "post"
  });
}

//获取卡片详情
export function getAirwallexCardCvv(params, emailCode) {
  return request({
    url: "/v1/admin/airwallex/card/cvv",
    method: "post",
    headers: {
      "email-code": emailCode
    },
    data: params
  });
}

//激活卡片
export function putCardStatus(params, emailCode) {
  return request({
    url: "/v1/admin/airwallex/card",
    method: "put",
    headers: {
      "email-code": emailCode
    },
    data: params
  });
}
export function postDepositTransfer(params, googleCode) {
  return request({
    url: "/v1/customers/asset/shareaccount-deposit",
    method: "post",
    headers: {
      "ga-code": googleCode
    },
    data: params
  });
}
export function postUqAccountDeposit(params, googleCode) {
  return request({
    url: "/v1/customers/asset/uqAccount-deposit",
    method: "post",
    headers: {
      "ga-code": googleCode
    },
    data: params
  });
}
export function getCustUqAccountDeposit(_ref) {
  var account = _ref.account,
    transfer_amount = _ref.transfer_amount;
  return request({
    url: "/v1/customers/asset/uqAccount-deposit",
    method: "post",
    data: {
      account: account,
      transfer_amount: transfer_amount
    }
  });
}

// 开卡：/v1/customers/holder-kyc/opencard  载荷
//{"acct_no":"echoerlast","card_no":"434797233000001****","card_type_id":"33000001","api_passphrase":"1","api_secret":"2","api_key":"1","operation_type":"0"}
// 激活：/v1/customers/holder-kyc/opencard  载荷
//{"acct_no":"echoerlast","card_no":"434797233000001****","card_type_id":"33000001","api_passphrase":"3","api_secret":"2","api_key":"1","operation_type":"1"}
export function postOpenCard(params, googleCode) {
  return request({
    url: "/v1/customers/holder-kyc/opencard",
    method: "post",
    headers: {
      "ga-code": googleCode
    },
    data: params
  });
}